// Pure in-game wall-clock time, derived from the shared day/night cycle.
// NO Phaser / gameState imports — inputs arrive as arguments so this runs under
// `node --test` and every client (owner or visitor) computes the same time.
//
// Mapping: one 240s cycle = 24 in-game hours → 1h = 10 real seconds. The cycle
// starts at 00:00 (night); morning 06:00, day 12:00, evening 18:00 (see PHASES).
import { DAY_CYCLE_SECONDS, PHASES } from '../ui/animalBehavior.js';

export const HOURS_PER_DAY = 24;
export const SECONDS_PER_HOUR = DAY_CYCLE_SECONDS / HOURS_PER_DAY;  // 10

export const PHASE_LABEL_PL = { night: 'noc', morning: 'rano', day: 'dzień', evening: 'wieczór' };

function phaseAt(s) {
  for (const [name, start, end] of PHASES) if (s >= start && s < end) return name;
  return PHASES[0][0];
}

function fromSeconds(s, phase) {
  const totalMinutes = Math.floor((s / SECONDS_PER_HOUR) * 60);
  const hours = Math.floor(totalMinutes / 60) % HOURS_PER_DAY;
  const minutes = totalMinutes % 60;
  // 12h dial: two turns per day, 30° per hour, minutes advance the hand continuously.
  const hourAngleDeg = ((hours % 12) + minutes / 60) * 30;
  return { hours, minutes, phase, hourAngleDeg };
}

// devPhase (dev T/R hotkeys) freezes the clock at that phase's start hour.
export function clockTime(nowMs, cycleStartedMs, devPhase = null) {
  if (devPhase) {
    const entry = PHASES.find(([name]) => name === devPhase) ?? PHASES[0];
    return fromSeconds(entry[1], entry[0]);
  }
  let s = ((nowMs - cycleStartedMs) / 1000) % DAY_CYCLE_SECONDS;
  if (s < 0) s += DAY_CYCLE_SECONDS;
  return fromSeconds(s, phaseAt(s));
}

// stepMinutes > 1 floors the minutes to that interval (e.g. 15 → :00/:15/:30/:45),
// so a display doesn't flicker through every in-game minute (1 real second = 6 minutes).
export function formatClock({ hours, minutes, phase }, { stepMinutes = 1 } = {}) {
  const stepped = Math.floor(minutes / stepMinutes) * stepMinutes;
  const hh = String(hours).padStart(2, '0');
  const mm = String(stepped).padStart(2, '0');
  return `${hh}:${mm} · ${PHASE_LABEL_PL[phase] ?? phase}`;
}
